import React from 'react';
import '../styles/Footer.css';
import {
  AiOutlineMail,
  AiOutlineFacebook,
  AiOutlineInstagram,
  AiOutlineLinkedin,
} from 'react-icons/ai';

const Footer = () => {
  return (
    <footer>
      <div className='footer-container'>
        <p className='footer-info'>© 2023 Qurtal All rights reserved.</p>
        <ul className='footer-socmed'>
          <li>
            <a
              href='mailto:aldo.wijaya2012@students.unila.ac.id'
              className='footer-socmed__link'
            >
              <AiOutlineMail className='footer-socmed__icon' />
            </a>
          </li>
          <li>
            <a href='#a' className='footer-socmed__link footer-socmed__fb'>
              <AiOutlineFacebook className='footer-socmed__icon' />
            </a>
          </li>
          <li>
            <a
              href='https://www.instagram.com/wijayaaldoo/'
              className='footer-socmed__link'
            >
              <AiOutlineInstagram className='footer-socmed__icon' />
            </a>
          </li>
          <li>
            <a
              href='https://www.linkedin.com/in/aldowijaya/'
              className='footer-socmed__link'
            >
              <AiOutlineLinkedin className='footer-socmed__icon' />
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
